<template>
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 64 64">
    <path
      fill="currentColor"
      d="M19.013 51c3.18 0 5.79-.987 7.834-2.962 2.044-1.974 3.066-4.563 3.066-7.767 0-2.236-.53-4.173-1.59-5.812-1.06-1.64-2.535-2.869-4.428-3.688L28.891 13h-11.24l-6.585 16.094c-1.287 2.98-2.12 5.216-2.498 6.706C8.189 37.29 8 38.78 8 40.27c0 3.13 1.04 5.7 3.122 7.712C13.204 49.994 15.834 51 19.013 51zM45.1 51c3.18 0 5.79-.987 7.834-2.962C54.978 46.064 56 43.475 56 40.271c0-2.236-.53-4.173-1.59-5.812-1.06-1.64-2.535-2.869-4.428-3.688L54.978 13h-11.24l-6.585 16.094c-1.287 2.98-2.12 5.216-2.498 6.706-.379 1.49-.568 2.98-.568 4.47 0 3.13 1.04 5.7 3.122 7.712C39.291 49.994 41.921 51 45.1 51z"
    />
  </svg>
</template>

<script lang="ts">
import Vue from 'vue'
export default Vue.extend({
  name: 'IconQuoteStart'
})
</script>
